/** Department views share tickets; Approved is the Product/Engineering handoff. */
export const TICKET_DEPARTMENTS = ['all', 'product', 'support', 'engineering', 'devops'];
export const PRODUCT_PREPARATION_STATUSES = ['backlog', 'design_needed', 'acceptance_criteria_needed', 'estimate_needed', 'needs_approval'];
export const ENGINEERING_STATUSES = ['approved', 'in_progress', 'ready_for_qa', 'qa', 'dev_done', 'ready_for_uat', 'uat', 'done'];
export const PRODUCT_STATUSES = ['cancelled', ...PRODUCT_PREPARATION_STATUSES, 'approved', 'rejected'];
export const DEVOPS_STATUSES = ['approved', 'in_progress', 'dev_done', 'uat', 'done'];
export function ticketDepartment(value) {
    return TICKET_DEPARTMENTS.includes(value) ? value : 'all';
}
const productTypes = 'type IN (feature_request, change_request, task, tech_debt, epic, subtask)';
export const DEPARTMENT_AQL = {
    all: '',
    product: `${productTypes} AND status IN (${[...PRODUCT_STATUSES, 'draft', 'submitted', 'triage', 'approved_for_agent'].join(', ')})`,
    engineering: `${productTypes} AND status IN (${[...ENGINEERING_STATUSES, 'approved_for_agent', 'agent_in_progress', 'internal_waiting', 'staging'].join(', ')})`,
    support: 'type IN (customer_support, internal_bug)',
    devops: 'type = infrastructure',
};
export const DEPARTMENT_LABEL = {
    all: 'All', product: 'Product', support: 'Support', engineering: 'Engineering', devops: 'DevOps',
};
//# sourceMappingURL=ticket-departments.js.map